
<template>
<div>
    <a-modal :title="modalState.title" :visible="modalState.isShow" :confirm-loading="confirmLoading" width="600px"
        @cancel="handleCancel">
        <a-input-search  style="width: 100%;margin-bottom:0px;" placeholder="请输入关键字" default-value=""  @search="onSearch" />
        <a-table
            :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange ,type:modalState.rowsType}"
            :columns="columns" :data-source="list" rowKey="kaenv" :pagination="false" :scroll="{ x: 560}" />

        <br />

        <a-pagination v-model="pagination.page" :total="pagination.total" @change="handlePageChange"
            style="float:right;" show-less-items />
        <br />

        <template slot="footer">
            <a-button key="back" @click="handleCancel">
                取消
            </a-button>
            <a-button key="submit" type="primary" :loading="confirmLoading" @click="handleOk">
                确定
            </a-button>
        </template>
    </a-modal>
</div>
  
</template>
<script>
let status = {
    0:'未使用',
    1:'使用中',
    2:'已销毁'
}
const columns = [
    { 
        title: '客户名称', 
        dataIndex: 'kadesc',
        align:'center',
        width:100, 
    },
    { 
        title: '客户编码', 
        dataIndex: 'kacode',
        align:'center',
        width:100, 
    },
    { 
        title: '环境编码', 
        dataIndex: 'kaenv',
        align:'center',
        width:100, 
    },
    { 
        title: '状态', 
        dataIndex: 'status',
        align:'center',
        customRender: (text) => {
            return status[text];
        },
        width:100, 
    },
];

export default {
    data() {
        return {
            confirmLoading: false,
            columns:columns,
            selectedRowKeys: [],
            list:[],
            searchVal:'',
            pagination:{
                page:1,
                total:0,
                pageSize:10,
            },
            modalState:{
                isShow:false,
                title:'选择KA环境',
                rowsType:'radio',
                selectkeys:undefined,
                filterAppcode:'',
                flag:0,
            }
        }
    },
    computed: {
        hasSelected() {
            return this.selectedRowKeys.length > 0;
        },
    },

    methods: {
        handlePageChange(params_page){
            this.pagination.page = params_page;
            this.onModalInit()
        },
        onModalInit(flag){
            let that = this;
            let c_params = {
                keyword:that.searchVal,
                ...that.pagination,
                urlparams:false,
            }
            that.$store.dispatch({
                type: "kamanager/queryaccountpage",
                params:c_params,
                showMsg: false
            }).then((res)=>{
                if(res.data.success == 1){
                    if(that.modalState.selectkeys){
                        that.selectedRowKeys = that.modalState.selectkeys
                    }
                    let result = res.data.data;
                    that.list = result.list;
                    that.selectedRowKeys = [];
                    if(that.list.length > 0 && flag == 1){
                        const {query} = this.$route;
                        if(query.kaenv){
                            this.selectedRowKeys.push(query.kaenv)
                        }
                        else{
                            that.selectedRowKeys.push(that.list[0].kaenv)
                        }
                        that.handleOk();
                    }
                    that.pagination.total = result.totalRecords;
                    that.pagination.pageSize = result.pageSize;
                    that.pagination.page = result.page;
                }
                else{
                    that.message.error('获取APP列表失败')
                }
            })
        },

        onSearch(value){
            this.searchVal = value;
            this.pagination.page = 1
            this.onModalInit(); 
        },
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
        },
        handleOk(){
            let target = this.list.filter(item => { return item.kaenv == this.selectedRowKeys[0] });
            this.$emit('onModalHide',target);
        },
        handleCancel(e) {
            e.preventDefault()
            this.$emit('onModalHide',undefined);
        }
    },
    mounted() {
        this.pagination.page = 1
        //初始化并取第一个
        this.onModalInit(1)
    },
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}
</style>
